module.exports = __webpack_public_path__ + "img/Flag_of_Nauru.a54cac9f.svg";